<div *ngIf="this.forgotPasawordStatus===2">
  <div class="basicrow f-lsemi roboto-r text-center">
      <div class="basicrow" [hidden]="this.actualRegisterViewStep === 'step11'">
          <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
          ¿Olvidaste tu contraseña?
      </div>
  </div>
  <div class="basicrow f-reg f-black roboto-r m-top-i text-justify">
      Escoje entre las opciones para recuperaci&oacute;n de acceso a tu cuenta.
  </div>

  <div class="basicrow">
      <div class="basicrow m-top-i">
          <input type="radio" [(ngModel)]="this.typeNotification" value="sms/email" (change)="onKey()"> V&iacute;a SMS o correo electr&oacute;nico
      </div>

      <div class="basicrow m-top">
          <input type="radio" [(ngModel)]="this.typeNotification" value="questions" (change)="onKey()"> Contestar preguntas de seguridad
      </div>
  </div>

  <div class="basicrow m-top-i">
      <a (click)="this.continue();" class="btns gray vcenter" [ngClass]="{'red': on, 'gray': !on}">
        <!-- step21 -->
<span class="tabcell">
Recuperar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
</span>
      </a>
  </div>
</div>